import { UnitType } from '@planning/app/api'
import { useTranslate } from '@tolgee/react'
import { GeneralIcon, SwapBodyIcon, TrailerIcon } from '@tom-ui/ui'

export const useUnitTypeIcon = (unitType?: UnitType) => {
  switch (unitType) {
    case UnitType.SwapBody:
      return <SwapBodyIcon />
    case UnitType.Trailer:
      return <TrailerIcon />
    default:
      return <GeneralIcon />
  }
}

export const useUnitTypeLabel = (unitType?: UnitType) => {
  const { t } = useTranslate()

  switch (unitType) {
    case UnitType.SwapBody:
      return t('swapBody', 'Swap Body')
    case UnitType.Trailer:
      return t('trailer', 'Trailer')
    default:
      return t('container', 'Container')
  }
}
